/**
 * @file     galleryModel.ts
 * @purpose  Shared gallery model for the listing photos: the media tabs, the
 *           LCP photo sizes and quality, and the street view link.
 */

export type GalleryTab = 'photos' | 'tour' | 'street' | 'map';

// The LCP photo. The phone carousel and the desktop bento both keep their
// first photo in the DOM (display toggles by breakpoint), so the two <img>s
// share ONE sizes string and one quality: identical srcset + sizes resolve to
// the same candidate URL, and the two priority preloads collapse into one.
// Below md the photo is full width; the bento gives it 2 of 4 fractions of a
// 1152px track (1200 max width minus the 24px gutters), less the 8px gaps.
export const HERO_SIZES = '(max-width: 899px) 100vw, (max-width: 1199px) 50vw, 568px';
export const HERO_QUALITY = 80;

export function streetViewUrl(
  addressQuery: string | undefined,
  latitude: number | null | undefined,
  longitude: number | null | undefined,
): string | null {
  if (latitude != null && longitude != null) {
    return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}`;
  }
  if (addressQuery) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressQuery)}`;
  }
  return null;
}
